import { TrustboxComponent } from '../../_components/trustbox/trustbox.component';
import { Component } from '@angular/core';
import { HeaderNewComponent } from '../../_components/header-new/header-new.component';
import { FooterComponent } from '../../_components/footer/footer.component';
import { Meta, Title } from '@angular/platform-browser';
import { NavbarComponent } from "../../V4/_components/navbar/navbar.component";

@Component({
    selector: 'app-installation-guide',
    imports: [TrustboxComponent, HeaderNewComponent, FooterComponent, NavbarComponent],
    templateUrl: './installation-guide.component.html',
    styleUrl: './installation-guide.component.scss'
})
export class InstallationGuideComponent {
  constructor(private meta: Meta, private title: Title) {}
  ngOnInit() {
    this.title.setTitle('Installation Guides | Paving, Decking & Fencing | Nustone');
    this.meta.addTag({
      name: 'description',
      content:
        "We'll talk you through all the best practices for installing our products, with tips and advice for the best results! 🛠️",
    });
    this.meta.addTag({ name: 'og:title', content:"Installation Guides | Paving, Decking & Fencing | Nustone"})
    this.meta.addTag({ name: 'og:description', content:"We'll talk you through all the best practices for installing our products, with tips and advice for the best results! 🛠️"})
  }
}
